import { Dispatch } from "redux"

import { CLOSE_MODAL } from "../../reducers/event-types/actions-types"
import { EVENT_TYPE_HTTP_ERR_RESPONSES_MESSAGES } from "../../constants/event-types-responses"

function validateStatusResponse(status: number, dispatch: Dispatch) {
  if (status >= 100 && status < 300) {
    dispatch({ type: CLOSE_MODAL })
  }

  const code = status as keyof typeof EVENT_TYPE_HTTP_ERR_RESPONSES_MESSAGES

  return EVENT_TYPE_HTTP_ERR_RESPONSES_MESSAGES[code]
}

export default validateStatusResponse
